"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Alert } from "@nxt-costco-com/forge-icons";
import { Text } from "../../DataDisplay/Text/index.js";
import { COMPONENT_NAME } from "./constants.js";
import { InputErrorStyles } from "./styles.js";
const InputError = (props) => {
  const {
    hasError,
    errorIconA11yAttributes,
    errorTextId,
    errorText,
    testId
  } = props;
  const styles = InputErrorStyles();
  if (!hasError || !errorText) return null;
  return /* @__PURE__ */ jsxs(
    Text,
    {
      variant: "t7",
      sx: styles.errorText,
      id: errorTextId,
      uniqueId: testId,
      children: [
        /* @__PURE__ */ jsx(Alert, { ...errorIconA11yAttributes, role: "img" }),
        /* @__PURE__ */ jsx("span", { dangerouslySetInnerHTML: { __html: errorText } })
      ]
    }
  );
};
InputError.displayName = COMPONENT_NAME;
export {
  InputError
};
